// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3M5TI","name":"ConsentHeader_name__2Sp2A","birthday":"ConsentHeader_birthday__39OYa","skeleton":"ConsentHeader_skeleton__1oDT9"};